import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Subject, takeUntil } from 'rxjs';

import {
  selectSettingsAccessCodeMaxLength,
  selectSettingsAccessCodeMinLength,
  selectSettingsAllowAlphanumeric,
} from 'src/app/stores/settings';

import { AlphaKeyboardComponent } from '../alpha-keyboard/alpha-keyboard.component';
import { NumericKeyboardComponent } from '../numeric-keyboard/numeric-keyboard.component';

@Component({
  selector: 'frodo-enter-code',
  templateUrl: './enter-code.component.html',
  styleUrls: ['./enter-code.component.scss'],
})
export class EnterCodeComponent implements OnInit, OnDestroy {
  @Input() title = '';
  @Input() isLoading = false;
  @Input() handleSubmit!: (code: string) => void;
  @Input() goBack?: () => void;
  @Input() viewType!: string;

  allowAlphanumeric = false;
  showBoxes = false;
  boxesLength = 0;

  @ViewChild(NumericKeyboardComponent) numericChild?: NumericKeyboardComponent;
  @ViewChild(AlphaKeyboardComponent) alphaChild?: AlphaKeyboardComponent;

  private destroy$ = new Subject<void>();

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.bindAccessCodeSettings();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  receiveOnFocusEvent(event: Event & { target: HTMLInputElement }): void {
    if (this.allowAlphanumeric) {
      this.alphaChild?.onInputFocus(event);
    } else {
      this.numericChild?.onInputFocus(event);
    }
  }

  receiveOnChangeEvent(index: number): void {
    if (!this.allowAlphanumeric) {
      this.numericChild?.focusNext(index);
    }
  }

  private bindAccessCodeSettings(): void {
    combineLatest([
      this.store.select(selectSettingsAllowAlphanumeric),
      this.store.select(selectSettingsAccessCodeMinLength),
      this.store.select(selectSettingsAccessCodeMaxLength),
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([allowAlphanumeric, minLength, maxLength]) => {
        this.allowAlphanumeric = allowAlphanumeric;
        this.showBoxes = minLength === maxLength;
        this.boxesLength = maxLength;
      });
  }
}
